import { render, staticRenderFns } from "./InstagramIcon.vue?vue&type=template&id=63457c21&functional=true&"
var script = {}
import style0 from "./InstagramIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63457c21')) {
      api.createRecord('63457c21', component.options)
    } else {
      api.rerender('63457c21', component.options)
    }
    module.hot.accept("./InstagramIcon.vue?vue&type=template&id=63457c21&functional=true&", function () {
      api.rerender('63457c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/InstagramIcon.vue"
export default component.exports